import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';
import { Card } from '@els/els-react--card';
import { ButtonWithIcon } from '@els/els-react--button';

function DocumentIndexTermsHit({ keywords, closeClick, trackingAttrs }) {
  const indexTermsHit = DocumentHitsFormat.checkAndFormatIndexTermsHit(keywords);

  return indexTermsHit ? (
    <Card className="result-detail-panel u-els-margin-top-1o2 e2e-document-action-index-terms-hit">
      <div className="result-detail-panel-wrapper u-els-display-flex">
        <h4 className="u-els-margin-right-1o2 u-els-font-family-bold">Index Terms Hit:</h4>
        <div className="u-els-display-flex">
          <InnerHTML tag="div" className="result-detail-block u-els-font-size-base u-els-line-height-default" html={indexTermsHit} />
          <ButtonWithIcon
            type="link"
            data-e2e="index-terms-hit-close"
            iconOnly
            linkIconSize="s"
            linkOptions={['navigation']}
            sprite="ChevronDown"
            {...trackingAttrs}
            className="result-detail-panel-wrapper-close e2e-close"
            data-automationid="sub-menu-close"
            onClick={() => {
              closeClick();
            }}>
            close
          </ButtonWithIcon>
        </div>
      </div>
    </Card>
  ) : null;
}

DocumentIndexTermsHit.propTypes = {
  keywords: PropTypes.array.isRequired,
  closeClick: PropTypes.func.isRequired,
  // for analytics
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentIndexTermsHit;
